<template>
  <div v-show="isLoaded" class="mSchedules_container" v-observe-visibility="startAnimate">
    <img class="mSchedules_img" :src="banner" alt="Banner Calendario">
    <!-- <img class="mSchedules_img_one" :src="banner_one" alt="Banner Calendario"> -->
    <h1 class="mSchedules_title" :class="{animate: animate}">Calendario</h1>
    <div class="mSchedule_cards">
        <div class="mSchedules_one" :class="{animate: animate}">
            <h3 class="mSchedules_subtitle"><u>Primera Fecha</u></h3>
            <h4 class="mSchedules_date">12 al 14 de abril</h4>
            <h3 class="mSchedules_subtitle one"><u>Cuatro Padel</u></h3>
            <img class="mSchedules_img" :src="padel" alt="Cuatro padel">
            <h4 class="mSchedules_direction" :class="{onlySafari: isSafari}">Av. Manuel Gómez Morin 1250, Carrizalejo, 66259 San Pedro <br>
                Garza García, N.L (Dentro del club Paléstino Libanés)
            </h4>
        </div>
        <div class="mSchedules_two card" :class="{animate: animate}">
            <h3 class="mSchedules_subtitle two"><u>Segunda Fecha</u></h3>
            <h4 class="mSchedules_date">28 al 30 de junio</h4>
            <h3 class="mSchedules_subtitle thee"><u>Padel Camp</u></h3>
            <img class="mSchedules_img camp" :src="camp" alt="Padel Camp">
            <h4 class="mSchedules_direction">Callejón capellanía no. 29 SPGG</h4>
        </div>
        <!-- <div class="mSchedules_thee card" :class="{animate: animate}">
            <h3 class="mSchedules_subtitle"><u>Tercera Fecha</u></h3>
            <h4 class="mSchedules_date">30 al 1 de agosto</h4>
            <h3 class="mSchedules_subtitle four"><u>Power Padel</u></h3>
            <img class="mSchedules_img power" :src="power_padel" alt="Power Padel">
            <h4 class="mSchedules_direction">Loma de los Pinos 500A, Col. Estanzuela</h4>
        </div> -->
        <div class="mSchedules_thee card" :class="{animate: animate}">
            <h3 class="mSchedules_subtitle"><u>Tercera Fecha</u></h3>
            <h4 class="mSchedules_date">20 al 22 de septiembre</h4>
            <h3 class="mSchedules_subtitle four"><u>Cuatro Padel</u></h3>
            <img class="mSchedules_img" :src="padel" alt="Cuatro padel">
            <h4 class="mSchedules_direction" :class="{onlySafari: isSafari}">Av. Manuel Gómez Morin 1250, Carrizalejo, 66259 San Pedro <br>
                Garza García, N.L (Dentro del club Paléstino Libanés)
            </h4>
        </div>
        <div class="mSchedules_four card" :class="{animate: animate}">
            <h3 class="mSchedules_subtitle"><u>Cuarta Fecha</u></h3>
            <h4 class="mSchedules_date">1 al 3 de noviembre</h4>
            <h3 class="mSchedules_subtitle five"><u>Padel Club</u> <br> <u>Santa María</u></h3>
            <img class="mSchedules_img club" :src="club" alt="Padel Club">
            <h4 class="mSchedules_direction">Av. la Rioja, 64985 Monterrey</h4>
        </div>
        <!-- <div class="mSchedules_five card" :class="{animate: animate}">
            <h3 class="mSchedules_subtitle six"><u>Quinta Fecha</u></h3>
            <h4 class="mSchedules_date">1 al 3 de noviembre</h4>
            <h3 class="mSchedules_subtitle seven"><u>Padel Club Santa María</u></h3>
            <img class="mSchedules_img club_two" :src="club" alt="Padel Club">
            <h4 class="mSchedules_direction">Aaron Sáenz Garza 1918, <br>
                Sin Nombre de Col 27, 64650 Monterrey, N.L.
            </h4>
        </div> -->
        <div class="mSchedules_six card" :class="{animate: animate}">
            <h3 class="mSchedules_subtitle"><u>Máster Final</u></h3>
            <h4 class="mSchedules_date">29 de noviembre al 1 de diciembre</h4>
            <h3 class="mSchedules_subtitle"><u>Cuatro Padel</u></h3>
            <img class="mSchedules_img" :src="padel" alt="Cuatro padel">
            <h4 class="mSchedules_direction">Av. Manuel Gómez Morin 1250, Carrizalejo, 66259 San Pedro <br>
                Garza García, N.L (Dentro del club Paléstino Libanés)
            </h4>
        </div>
    </div>
  </div>
</template>

<script>
import banner from "@/assets/home/calendar_two.png";
import banner_one from "@/assets/calendar_one.jpg";
import padel from '@/assets/cuatro_padel_one.png'
import camp from '@/assets/padel_camp_one.png'
import power_padel from '@/assets/power_padel.png'
import club from '@/assets/padel_club_one.png'
import { mapGetters } from "vuex";
import Bowser from "bowser"; 
export default {
    name: "Schedules",
    data() {
        return {
            animate: false,
            isSafari: false,
            banner,
            banner_one,
            padel,
            camp,
            power_padel,
            club,
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true;
            }
        },
    },
    mounted() {
        window.scrollTo(0,0)
    },
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Schedules.scss";
</style>